export const isErrorWithStatus = ( statusCode, statusText ) => error => (
	error
		&& error.status === statusCode
		&& ( !statusText || ( !!error.data && error.data.error === statusText ) )
);
